import { Box, Grid, Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import moment from "moment";
import * as React from "react";
import { FontFamilySwitch } from "../../utils";

const useStyles = makeStyles((theme) => ({
  root: {
    background: "#FFFFFF",
    margin: "0px",
    padding: "4px",
    border: "1px solid #E4E8EE",
    borderRadius: theme.palette.borderRadius,
    boxShadow: "0px 3px 30px #5C86CB2E",
    textAlign: "center",
    cursor: "pointer",
  },
  detailsActionCard: {
    margin: "0px",
    padding: "12px",
    color: "#FFFFFF",
    //backgroundImage: `url(${"/images/Group_4563.svg"})`,
    backgroundRepeat: "no-repeat",
    backgroundColor: "#5078E1",
    backgroundPositionX: "100%",
    backgroundPositionY: "100%",
    borderRadius: "4px",
    border: "1px solid #E4E8EE",
    justifyContent: "space-between",
    alignItems: "center",
  },
  payActionCard: {
    margin: "0px",
    padding: "12px",
    color: "#FFFFFF",
    backgroundImage: `url(${"/images/icons8-cash-receipt.svg"})`,
    backgroundRepeat: "no-repeat",
    backgroundColor: "#5078E1",
    backgroundPositionX: "85%",
    backgroundPositionY: "50%",
    borderRadius: "4px",
    border: "1px solid #E4E8EE",
    justifyContent: "space-between",
    alignItems: "center",
  },
  extraDetailsStyle: {
    padding: "16px",
  },
  title: {
    fontSize: "1rem",
    fontFamily: FontFamilySwitch().bold,
    color: "white",
    textAlign: "left",
  },
  subTitle: {
    fontSize: "0.75rem",
    color: "white",
    textAlign: "left",
    fontFamily: FontFamilySwitch().regular
  },
  lable: {
    fontSize: "0.75rem",
    color: "#98A0AC",
    fontFamily: FontFamilySwitch().regular,
    textAlign: "left",
  },
  value: {
    fontSize: "0.75rem",
    color: "#071741",
    fontFamily: FontFamilySwitch().semiBold,
    textAlign: "left",
  },
  dividerStyle: {
    backgroundColor: "#E4E8EE",
    width: "1px",
    height: "24px",
  },
  iconButtonStyle: {
    background: "white",
    height: "24px",
    width: "24px",
  },
}));
export const QuotationCard = (props) => {
  const { t=()=>false } = (props)
  const classes = useStyles();

  return (
    <Grid
      onClick={props.onClick}
      container
      direction="column"
      className={classes.root}
    >
      <Grid
        container
        direction="row"
        className={
          props?.type === "details"
            ? classes.detailsActionCard
            : classes.payActionCard
        }
      >
        <Grid container sm={11} xs={11} direction="column">
          <Typography className={classes.title}>
            {props?.type === "details"
              ? t("Quotation")
              : t("Pay against quotation #") + props?.quotationNo}
          </Typography>
          <Typography className={classes.subTitle}>
            {props?.type === "details"
              ? t("Generated On ") + props?.generatedOn ? moment(props?.generatedOn).tz(moment.tz.guess()).format("DD MMM YY") : ""
              : t("Expires On ") + props?.expiresOn ? moment(props?.expiresOn).tz(moment.tz.guess()).format("DD MMM YY") : ""}
          </Typography>
        </Grid>
        {/* <Grid
          container
          sm={1}
          xs={1}
          justifyContent="right"
          alignItems="center"
        >
          <IconButton
            onClick={props.onClick}
            className={classes.iconButtonStyle}
          >
            <ChevronRightIcon />
          </IconButton>
        </Grid> */}
      </Grid>
      {props?.type === "details" && (
        <Grid
          container
          className={classes.extraDetailsStyle}
          direction="row"
          justifyContent="space-around"
          alignItems="center"
        >
          <Grid item direction="column">
            <Typography className={classes.lable}>{t("Quotation No")}</Typography>
            <Box height="4px" />
            <Typography className={classes.value}>
              {"#" + props?.quotationNo}
            </Typography>
          </Grid>
          <Box className={classes.dividerStyle} />
          <Grid item direction="column">
            <Typography className={classes.lable}>{t("Expires On")}</Typography>
            <Box height="4px" />
            <Typography className={classes.value}>
              {props?.expiresOn ? moment(props?.expiresOn).tz(moment.tz.guess()).format("DD MMM YY") : ""}
            </Typography>
          </Grid>
          <Box className={classes.dividerStyle} />
          <Grid item direction="column">
            <Typography className={classes.lable}>{t("Lease Period")}</Typography>
            <Box height="4px" />
            <Typography className={classes.value}>
              {props?.leasePeriod}
            </Typography>
          </Grid>
        </Grid>
      )}
    </Grid>
  );
};
